// src/api/newsApi.js
const API_BASE_URL = process.env.REACT_APP_API_URL ;
// const API_BASE_URL = "https://localhost:44343";

export const fetchAllNews = async () => {
  const response = await fetch(`${API_BASE_URL}/api/news`);
  if (!response.ok) throw new Error("Failed to fetch news");
  return response.json();
};

export const fetchNewsBySlug = async (slug) => {
  const response = await fetch(`${API_BASE_URL}/api/news/${slug}`);
  if (!response.ok) throw new Error("News article not found");
  return response.json();
};
